import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import type { TicketSocketPayload } from './logiciel-caisse-socket.service';

/** Établissement courant du filtre POS (repris lors du transfert vers facture). */
export interface LcSelectedEstablishment {
  id: number;
  label: string;
  code: string | null;
}

@Injectable({ providedIn: 'root' })
export class LogicielCaisseTicketSelectionService {
  private readonly selectedSubject = new BehaviorSubject<Set<string>>(new Set());
  readonly selectedIds$ = this.selectedSubject.asObservable();

  private readonly refreshSubject = new Subject<{ snapDateToToday?: boolean }>();
  readonly refreshRequested$ = this.refreshSubject.asObservable();

  private readonly socketTicketSubject = new Subject<TicketSocketPayload>();
  /** MAJ incrémentale d’une ligne ticket (socket) — pas de reload tableau. */
  readonly socketTicketUpdate$ = this.socketTicketSubject.asObservable();

  private readonly countsRefreshSubject = new Subject<void>();
  readonly countsRefreshRequested$ = this.countsRefreshSubject.asObservable();

  /** Établissement sélectionné dans le filtre POS (null si aucun / plusieurs indéterminés). */
  private selectedEstablishment: LcSelectedEstablishment | null = null;

  setSelectedEstablishment(etab: LcSelectedEstablishment | null): void {
    this.selectedEstablishment = etab;
  }

  getSelectedEstablishment(): LcSelectedEstablishment | null {
    return this.selectedEstablishment;
  }

  getSelectedCount(): number {
    return this.selectedSubject.value.size;
  }

  getSelectedIds(): number[] {
    return [...this.selectedSubject.value]
      .map((id) => Number(id))
      .filter((n) => Number.isFinite(n) && n > 0);
  }

  setSelectedIds(ids: Set<string>): void {
    this.selectedSubject.next(new Set(ids));
  }

  clear(): void {
    this.selectedSubject.next(new Set());
  }

  requestListRefresh(options?: { snapDateToToday?: boolean }): void {
    this.refreshSubject.next(options ?? {});
  }

  requestSocketTicketUpdate(payload: TicketSocketPayload): void {
    if (payload?.document_id != null) {
      this.socketTicketSubject.next(payload);
    }
  }

  /** Recalcule les compteurs d’onglets (Tous / Tické / …). */
  requestCountsRefresh(): void {
    this.countsRefreshSubject.next();
  }
}
